/**
 * Makes menu sticky.
 */

import stickybits from 'stickybits';

jQuery( $ => {
	const stickyArgs = {
		useStickyClasses: true,
	};

	// Setting sticky menu offset to the same height as wpadminbar.
	if ( 0 < $( 'body.admin-bar' ).length ) {
		stickyArgs.stickyBitStickyOffset = 32;
	}

	const stickyHeader = stickybits( '.site-header', stickyArgs );
	console.log( 'stickyheader is up and running yall!' ); // eslint-disable-line no-console

	$( window ).on( 'svensktfiske-articles-loaded', () => {
		console.log( 'Uodating stickyheader!' ); //eslint-disable-line no-console
		stickyHeader.update();
	} );
} );
